import * as React from 'react';
import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Types
import { IStore } from '../../store/Store';

// Utilities
import { required, between, email } from '../../utilities/validation';

// Services
import { forgotPassword } from '../../services/auth';

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import { AlertDialog } from '../../components/Dialog';
import Divider from '../../components/Divider';
import { Form, TextField } from '../../components/FormStateFields';
import Icon from '../../components/Icon';
import { EntryLayout } from '../../components/Layout';
import LinkButton from '../../components/LinkButton';
import MobileStepper from '../../components/MobileStepper';
import Typography from '../../components/Typography';

// FormState
class ForgotForm {
  username = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(5, 100), email);

  state = new FormState({
    username: this.username
  });

  gerValues() {
    return {
      username: this.username.$
    };
  }
}

// Component
interface IProps {
  store?: IStore;
}
class Forgot extends React.Component<IProps, {}> {
  form = new ForgotForm();

  @observable
  alertDialogState = {
    status: 'none',
    open: false,
    title: '',
    description: ''
  };

  @action
  handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const validation = await this.form.state.validate();

    if (validation.hasError === false) {
      try {
        await forgotPassword({ body: { username: this.form.username.$ } });
        this.handleSuccessDialogOpen();
      } catch (error) {
        this.handleErrorDialogOpen();
      }
    }
  };

  @action
  handleSuccessDialogOpen = () => {
    this.alertDialogState = {
      status: 'success',
      open: true,
      title: 'Password is reset',
      description:
        'Your password is successfully reset. Please check you email for a reset link from Spotter.'
    };
  };

  @action
  handleErrorDialogOpen = () => {
    this.alertDialogState = {
      status: 'error',
      open: true,
      title: 'We couldn not find you...',
      description: 'Please try again with another email.'
    };
  };

  handleDialogConfirm = () => {
    if (this.alertDialogState.status === 'success') {
      this.props.store!.routerStore!.navigate(ROUTE_PATHS.LOGIN);
    }
    this.handleDialogClose();
  };

  handleDialogClose = () => {
    this.alertDialogState.open = false;
  };

  render() {
    return (
      <EntryLayout>
          <Form
            onSubmit={this.handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              width: '100%'
            }}
          >
            <div
              style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Box pa={4}>
                <Typography type="headline">Forgot Password</Typography>
                <Typography type="body1" color="textSecondary">
                  We'll send you a link to reset your password.
                </Typography>
                <TextField
                  label="Email"
                  type="email"
                  fieldState={this.form.username}
                  margin="normal"
                  fullWidth={true}
                />
              </Box>
            </div>
            <div>
              <Divider />
              <MobileStepper
                type="dots"
                position="static"
                backButton={
                  <LinkButton routeName={ROUTE_PATHS.LOGIN} dense={true}>
                    <Icon>keyboard_arrow_left</Icon>
                    Login
                  </LinkButton>
                }
                nextButton={
                  <Button type="submit" dense={true}>
                    Reset
                    <Icon>keyboard_arrow_right</Icon>
                  </Button>
                }
                steps={1}
              />
            </div>
          </Form>
        <AlertDialog
          state={this.alertDialogState}
          onClose={this.handleDialogClose}
          onConfirm={this.handleDialogConfirm}
        />
      </EntryLayout>
    );
  }
}

export default inject('store')(observer(Forgot));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Forgot/Forgot.tsx